import { SlugProductEntity } from '@mediashop/app/store/reducer/product';
import { AssetTag, Variant, VariantAsset } from '@mediashop/app/api/types/ClientProduct';
import { DetailedProduct } from '@mediashop/app/api/types/ClientProductDetailed';
import NoImageAvailable from '@mediashop/base/assets/images/NoImageAvailable.jpg';

/**
 * Get product with variants without price being removed
 *
 * @param foundProduct
 */
export const filterProductVariantsWithoutPrice = (foundProduct: SlugProductEntity): DetailedProduct | undefined => {
    if (foundProduct?.product) {
        const variantsWithPrice = foundProduct.product.variants.filter((variant) => Boolean(variant.price));
        if (variantsWithPrice.length > 0) {
            return {
                ...foundProduct.product,
                variants: variantsWithPrice,
            };
        }
        return { ...foundProduct.product };
    }

    return undefined;
};

/**
 * Get images for PDP
 * @param isVariantSelected is variant selected by user
 * @param variant selected variant
 * @returns list of sorted variant assets
 */
export const selectProductDetailImages = (
    isVariantSelected: boolean,
    variant?: Variant,
    isOnlyOneVariantActive?: boolean
): VariantAsset[] => {
    if (!variant) {
        return [];
    }

    let assets: VariantAsset[] = variant.assets ?? [];
    if (isVariantSelected || isOnlyOneVariantActive) {
        assets = assets.filter((image) => image.tags?.includes(AssetTag.PRODUCT_IMAGE));
    } else {
        assets = assets.filter((item) => item.isGlobal && item.tags?.includes(AssetTag.PRODUCT_IMAGE));
    }

    if (assets.length === 0) {
        assets.push({
            custom: {
                customFieldsRaw: [],
            },
            description: '',
            id: 'no-image-available',
            key: 'no-image-available',
            name: 'no-image-available',
            sources: [{ uri: NoImageAvailable }],
            tags: [AssetTag.PRODUCT_IMAGE],
        });
    }
    return assets;
};
